/**
 * Trust strip (sections/sm-home-trust.liquid): the Play/Pause control of the CSS marquee.
 * The loop, the hover pause and the reduced-motion grid are CSS; this only flips the state.
 */
class SmHomeTrust extends HTMLElement {
  #abort;

  connectedCallback() {
    const toggle = this.querySelector('[data-sm-home-trust-toggle]');
    if (!toggle) return;
    const label = toggle.querySelector('[data-sm-home-trust-label]');
    const { labelPlay, labelPause, ariaPlay, ariaPause } = toggle.dataset;
    this.#abort = new AbortController();
    toggle.addEventListener(
      'click',
      () => {
        const paused = this.classList.toggle('is-paused');
        label.textContent = paused ? labelPlay : labelPause;
        toggle.setAttribute('aria-label', paused ? ariaPlay : ariaPause);
      },
      { signal: this.#abort.signal }
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }
}

if (!customElements.get('sm-home-trust')) customElements.define('sm-home-trust', SmHomeTrust);
